import type { Favorite } from "@cosmosai/shared";
import { usePreferences, useUpdatePreferences } from "./api";

const same = (a: Favorite, b: Favorite) => a.workspace === b.workspace && a.ref === b.ref;

/** The favorite specs of a workspace, saved with the preferences; `ready` once they are loaded. */
export function useFavorites(workspace: string) {
  const { data } = usePreferences();
  const { mutate } = useUpdatePreferences();
  const all = data?.favorites ?? [];
  const isFavorite = (ref: string) => all.some((f) => same(f, { workspace, ref }));
  const toggle = (ref: string) => {
    // Before the saved list is known, a toggle would overwrite it: ignore it.
    if (!data) return;
    const favorite = { workspace, ref };
    mutate({
      favorites: isFavorite(ref) ? all.filter((f) => !same(f, favorite)) : [...all, favorite],
    });
  };
  return {
    ready: data !== undefined,
    favorites: all.filter((f) => f.workspace === workspace),
    isFavorite,
    toggle,
  };
}
